module.exports = __webpack_public_path__ + "img/stylistForm.cbbc8628.jpg";